export default "__VITE_ASSET__7104404d__"